import * as React from "react"
import * as styles from "src/components/organisms/FAQ/styles.module.scss"
import {FaqProps} from "src/components/organisms/FAQ";

export const MockFaqData: FaqProps = {
    items: [
        {
            title: "General",
            items: [
                {
                    questionTxt: "01. What is Alpaquita Linux?",
                    children: (
                        <p className={styles.question_text}>
                            Alpaquita Linux is a lightweight and secure distribution built on Alpine Linux, optimized to run Java workloads in cloud and container environments. It offers reliability, resource efficiency, and enterprise-grade security.
                        </p>
                    ),
                },
                {
                    questionTxt: "02. How is Alpaquita different from Alpine?",
                    children: (
                        <p className={styles.question_text}>
                            Alpaquita is distinguished by multiple performance and security optimizations and LTS releases
                            optimal for enterprise use. Alpaquita comes with three additional malloc for various workloads
                            and best Java support. In addition, we enhanced stock musl libc. Our musl perf is similar or
                            superior to glibc performance. We also provide two Alpaquita variants based on musl perf or glibc.
                        </p>
                    ),
                },
                {
                    questionTxt: "03. What is the difference between Alpaquita Stream and Alpaquita LTS?",
                    children: (
                        <p className={styles.question_text}>
                            Alpaquita Stream is a free rolling release of Alpaquita with the latest updates and fixes.
                            Alpaquita LTS is a stable version supported for four years with two-years overlap with the
                            previous version.
                        </p>
                    ),
                },
                {
                    questionTxt: "04. What C library implementation does Alpaquita support?",
                    children: (
                        <p className={styles.question_text}>
                            Alpaquita comes in two versions, musl and glibc-based. Our musl perf is 100% compatible with
                            musl def (a default musl implementation similar to the upstream release version), but boasts
                            performance enhancements making it as efficient as glibc.
                        </p>
                    ),
                },
                {
                    questionTxt: "05. How do I switch to Alpaquita?",
                    children: (
                        <p className={styles.question_text}>
                            The process of migrating to Alpaquita depends on several factors, such as libraries utilized for
                            development (statically or dynamically linked) and so on. If you build an application outside
                            Docker and copy the binary into the Docker image, simply substitute the image you are currently using.
                        </p>
                    ),
                },
            ],
        },

        {
            title: "Security and updates",
            items: [
                {
                    questionTxt: "01. What security features does Alpaquita Linux offer?",
                    children: (
                        <p className={styles.question_text}>Alpaquita Linux is designed to meet the stringent requirements of a secure software supply chain. It reduces attack surfaces with its minimal and hardened design, offering security advisories and regular updates. With long-term support (LTS) releases and SLAs, Alpaquita provides a reliable and secure foundation for server and cloud deployments.
                        </p>
                    )
                },
                {
                    questionTxt: "02. How is Alpaquita licensed?",
                    children: (
                        <p className={styles.question_text}>
                            Alpaquita is distributed under EULA (End-user license agreement) &mdash; we verified all the
                            packages regarding clean licenses and substituted some software to eliminate the risk of
                            license violation.
                        </p>
                    )
                },
                {
                    questionTxt: "03. How is Alpaquita updated?",
                    children: (
                        <p className={styles.question_text}>

                            Alpaquita Stream is continually updated with fresh packages, features, and fixes. It can be
                            used by developers who want the latest software, but is not recommended for enterprise
                            applications requiring stability. Alpaquita
                            LTS is aligned with Linux

                            Kernel LTS. It is a stable production-grade version with a focus on security patches and
                            critical fixes without significant package changes.
                        </p>

                    )
                },
                {

                    questionTxt: "04. How do I get updates for Alpaquita?",
                    children: (
                        <p className={styles.question_text}>
                            Alpaquita uses APK as a package manager. Use apk update to update the index of
                            available packages and apk upgrade
                            to upgrade the currently installed packages. Docker images, ISO, and WSL are also
                            regularly updated and available from the corresponding locations.
                        </p>
                    )
                },
            ]
        },
        {
            title: "Support",
            items: [
                {
                    questionTxt: "01. Is Alpaquita free?",
                    children: (
                        <p className={styles.question_text}>Alpaquita Stream is free to use. In addition, we offer enterprise-grade support for Alpaquita Cloud Native Platform.</p>
                    )
                },
                {
                    questionTxt: "02. What does BellSoft deliver with Alpaquita support?",
                    children: (
                        <p className={styles.question_text}>

                            BellSoft's subscription model includes 24x7 support both for Linux and Java, Alpaquita LTS versions, and emergency patches and bug fixes. There is no man-in-the-middle, meaning that you receive prompt help directly
                            from our engineers.

                        </p>
                    )
                },
                {
                    questionTxt: "03. What support plans are available?",
                    children: (
                        <p className={styles.question_text}>

                            We provide Standard and Premium support for our customers. Both options include emergency security patches, off-cycle updates and fixes, and a two-hour initial consultation. The response times are as fast as 24 hours based
                            on SLA for Standard subscription and 1 hour for Premium. Premium customers also get a dedicated engineer.
                        </p>
                    )
                },
                {
                    questionTxt: "04. What is BellSoft's support cycle for Alpaquita?",
                    children: (
                        <p className={styles.question_text}>We provide updates for Alpaquita LTS for min. four years with two-year overlap between the latest versions.             </p>
                    )
                },
            ]
        },
        {
            title: "Availability",
            items: [
                {
                    questionTxt: "01. Does Alpaquita have a desktop version?",
                    children: (
                        <p className={styles.question_text}>
                            No. Alpaquita is tailored specifically for Cloud/Server deployments with low resource
                            consumption and high performance in mind. To keep it lightweight, we refrained from the GUI
                            functionality.
                        </p>
                    )
                },
                {
                    questionTxt: "02. What platforms are supported?",
                    children: (
                        <p className={styles.question_text}>
                            Alpaquita Linux supports both x86 and AArch64 hardware architectures,
                            providing flexibility and compatibility for a wide range of systems.
                        </p>
                    )
                },
                {
                    questionTxt: "03. Does Alpaquita support Docker?",
                    children: (
                        <p className={styles.question_text}>Alpaquita comes with Docker and QEMU support. </p>
                    )
                },
                {
                    questionTxt: "04. How do I download Alpaquita?",
                    children: (
                        <p className={styles.question_text}>There are several ways of obtaining Alpaquita
                            binary: directly from our website, Linux repositories, or Docker Hub Container Image
                            Library. </p>
                    )
                },
                {
                    questionTxt: "05. Which programming languages can Alpaquita be used with?",
                    children: (
                        <p className={styles.question_text}>
                            Alpaquita Linux supports various languages for application
                            development &mdash; Java, Python, C/C++. It is also compatible with Liberica
                            NIK, a GraalVM-based utility for native image generation.
                        </p>
                    )
                },
            ]
        },
        {
            title: "Alpaquita containers",
            items: [
                {
                    questionTxt: "01. What is a small Linux for containers?",
                    children: (
                        <p className={styles.question_text}>

                            A lightweight Linux distribution contributes to significant container size
                            reduction. Such distribution contains only the libraries your application needs plus
                            optional packages you can remove or add as required.

                        </p>
                    )
                },
                {
                    questionTxt: "02. What is included into Alpaquita containers?",
                    children: (
                        <div className={styles.question_text}>
                            BellSofts provides an extensive selection of Alpaquita containers:
                            <ul className={styles.question_text_list}>
                                <li>Alpaquita base includes only the base Linux image</li>
                                <li>Liberica Runtime Container comprises of Alpaquita and
                                    Liberica Lite JDK or JRE;
                                </li>
                                <li>Liberica Native Image Kit Container is made up of
                                    GraalVM-based Liberica NIK and Alpaquita
                                </li>
                                <li>We also provide Alpaquita images for Python and C/C++</li>
                            </ul>
                        </div>
                    )
                },
                {
                    questionTxt: "03. How to install additional Linux packages?",
                    children: (
                        <p className={styles.question_text}>
                            You can add, list, remove, or update packages with the APK Package Manager tool that
                            comes pre-installed on all Alpaquita versions. A comprehensive guide on working with
                            APK on Alpaquita can be
                            found <a
                            href={`${process.env.GATSBY_PACKAGES_BELLSW_BASE}/ui/contents/`}>here</a>.
                        </p>
                    )
                }
            ]
        },
    ]
}
